// Generated by scripts/build-game-map.js. Do not edit by hand.
// Every FBS team's home stadium, keyed by teams.id. x and y are positions
// on the usMap.js box.

const STADIUMS = {
  "air-force": {
    "stadium": "Falcon Stadium",
    "city": "Colorado Springs",
    "state": "CO",
    "capacity": 46692,
    "lat": 38.997,
    "lon": -104.844,
    "x": 343.8,
    "y": 291
  },
  "akron": {
    "stadium": "InfoCision Stadium",
    "city": "Akron",
    "state": "OH",
    "capacity": 30000,
    "lat": 41.073,
    "lon": -81.508,
    "x": 742.9,
    "y": 232
  },
  "alabama": {
    "stadium": "Bryant-Denny Stadium",
    "city": "Tuscaloosa",
    "state": "AL",
    "capacity": 101821,
    "lat": 33.208,
    "lon": -87.55,
    "x": 657.2,
    "y": 423.7
  },
  "app-state": {
    "stadium": "Kidd Brewer Stadium",
    "city": "Boone",
    "state": "NC",
    "capacity": 30000,
    "lat": 36.211,
    "lon": -81.685,
    "x": 756.7,
    "y": 342.5
  },
  "arizona": {
    "stadium": "Arizona Stadium",
    "city": "Tucson",
    "state": "AZ",
    "capacity": 50782,
    "lat": 32.229,
    "lon": -110.949,
    "x": 213.8,
    "y": 430.7
  },
  "arizona-state": {
    "stadium": "Mountain America Stadium",
    "city": "Tempe",
    "state": "AZ",
    "capacity": 65870,
    "lat": 33.426,
    "lon": -111.933,
    "x": 199.8,
    "y": 400.7
  },
  "arkansas": {
    "stadium": "Razorback Stadium",
    "city": "Fayetteville",
    "state": "AR",
    "capacity": 80000,
    "lat": 36.068,
    "lon": -94.179,
    "x": 531.1,
    "y": 365
  },
  "arkansas-state": {
    "stadium": "Centennial Bank Stadium",
    "city": "Jonesboro",
    "state": "AR",
    "capacity": 30382,
    "lat": 35.849,
    "lon": -90.668,
    "x": 595.1,
    "y": 367.6
  },
  "army": {
    "stadium": "Michie Stadium",
    "city": "West Point",
    "state": "NY",
    "capacity": 38000,
    "lat": 41.387,
    "lon": -73.964,
    "x": 866.9,
    "y": 200.6
  },
  "auburn": {
    "stadium": "Jordan-Hare Stadium",
    "city": "Auburn",
    "state": "AL",
    "capacity": 87451,
    "lat": 32.603,
    "lon": -85.49,
    "x": 697.4,
    "y": 433.5
  },
  "ball-state": {
    "stadium": "Scheumann Stadium",
    "city": "Muncie",
    "state": "IN",
    "capacity": 22500,
    "lat": 40.216,
    "lon": -85.416,
    "x": 679.4,
    "y": 260.2
  },
  "baylor": {
    "stadium": "McLane Stadium",
    "city": "Waco",
    "state": "TX",
    "capacity": 45140,
    "lat": 31.558,
    "lon": -97.116,
    "x": 476.5,
    "y": 468.3
  },
  "boise-state": {
    "stadium": "Albertsons Stadium",
    "city": "Boise",
    "state": "ID",
    "capacity": 36387,
    "lat": 43.603,
    "lon": -116.196,
    "x": 170.2,
    "y": 158
  },
  "boston-college": {
    "stadium": "Alumni Stadium",
    "city": "Chestnut Hill",
    "state": "MA",
    "capacity": 44500,
    "lat": 42.335,
    "lon": -71.166,
    "x": 907.1,
    "y": 168.1
  },
  "bowling-green": {
    "stadium": "Doyt L. Perry Stadium",
    "city": "Bowling Green",
    "state": "OH",
    "capacity": 24000,
    "lat": 41.378,
    "lon": -83.622,
    "x": 706.5,
    "y": 230.1
  },
  "buffalo": {
    "stadium": "UB Stadium",
    "city": "Amherst",
    "state": "NY",
    "capacity": 30270,
    "lat": 42.999,
    "lon": -78.778,
    "x": 780.7,
    "y": 181
  },
  "byu": {
    "stadium": "LaVell Edwards Stadium",
    "city": "Provo",
    "state": "UT",
    "capacity": 63470,
    "lat": 40.258,
    "lon": -111.655,
    "x": 230.6,
    "y": 247.3
  },
  "california": {
    "stadium": "California Memorial Stadium",
    "city": "Berkeley",
    "state": "CA",
    "capacity": 62467,
    "lat": 37.871,
    "lon": -122.251,
    "x": 38.3,
    "y": 260.1
  },
  "central-michigan": {
    "stadium": "Kelly/Shorts Stadium",
    "city": "Mount Pleasant",
    "state": "MI",
    "capacity": 30255,
    "lat": 43.578,
    "lon": -84.771,
    "x": 681.3,
    "y": 182.7
  },
  "charlotte": {
    "stadium": "Jerry Richardson Stadium",
    "city": "Charlotte",
    "state": "NC",
    "capacity": 15300,
    "lat": 35.311,
    "lon": -80.74,
    "x": 776.9,
    "y": 360.2
  },
  "cincinnati": {
    "stadium": "Nippert Stadium",
    "city": "Cincinnati",
    "state": "OH",
    "capacity": 40000,
    "lat": 39.131,
    "lon": -84.516,
    "x": 697.7,
    "y": 283.1
  },
  "clemson": {
    "stadium": "Memorial Stadium",
    "city": "Clemson",
    "state": "SC",
    "capacity": 81500,
    "lat": 34.679,
    "lon": -82.843,
    "x": 740.7,
    "y": 380.3
  },
  "coastal-carolina": {
    "stadium": "Brooks Stadium",
    "city": "Conway",
    "state": "SC",
    "capacity": 21000,
    "lat": 33.793,
    "lon": -79.017,
    "x": 814.2,
    "y": 389.1
  },
  "colorado": {
    "stadium": "Folsom Field",
    "city": "Boulder",
    "state": "CO",
    "capacity": 50183,
    "lat": 40.009,
    "lon": -105.267,
    "x": 338.7,
    "y": 267.3
  },
  "colorado-state": {
    "stadium": "Canvas Stadium",
    "city": "Fort Collins",
    "state": "CO",
    "capacity": 36500,
    "lat": 40.57,
    "lon": -105.088,
    "x": 343,
    "y": 254.8
  },
  "delaware": {
    "stadium": "Delaware Stadium",
    "city": "Newark",
    "state": "DE",
    "capacity": 22000,
    "lat": 39.662,
    "lon": -75.749,
    "x": 845.8,
    "y": 245.8
  },
  "duke": {
    "stadium": "Wallace Wade Stadium",
    "city": "Durham",
    "state": "NC",
    "capacity": 40004,
    "lat": 35.995,
    "lon": -78.942,
    "x": 806.6,
    "y": 339.2
  },
  "east-carolina": {
    "stadium": "Dowdy-Ficklen Stadium",
    "city": "Greenville",
    "state": "NC",
    "capacity": 50000,
    "lat": 35.597,
    "lon": -77.365,
    "x": 836.6,
    "y": 342.8
  },
  "eastern-michigan": {
    "stadium": "Rynearson Stadium",
    "city": "Ypsilanti",
    "state": "MI",
    "capacity": 30200,
    "lat": 42.256,
    "lon": -83.647,
    "x": 703.5,
    "y": 210.3
  },
  "florida": {
    "stadium": "Ben Hill Griffin Stadium",
    "city": "Gainesville",
    "state": "FL",
    "capacity": 88548,
    "lat": 29.65,
    "lon": -82.349,
    "x": 766.2,
    "y": 492.5
  },
  "florida-atlantic": {
    "stadium": "FAU Stadium",
    "city": "Boca Raton",
    "state": "FL",
    "capacity": 29419,
    "lat": 26.376,
    "lon": -80.102,
    "x": 822.3,
    "y": 558.6
  },
  "florida-international": {
    "stadium": "Pitbull Stadium",
    "city": "Miami",
    "state": "FL",
    "capacity": 20000,
    "lat": 25.753,
    "lon": -80.378,
    "x": 819,
    "y": 573.4
  },
  "florida-state": {
    "stadium": "Doak Campbell Stadium",
    "city": "Tallahassee",
    "state": "FL",
    "capacity": 67277,
    "lat": 30.438,
    "lon": -84.304,
    "x": 725.8,
    "y": 479.8
  },
  "fresno-state": {
    "stadium": "Valley Children's Stadium",
    "city": "Fresno",
    "state": "CA",
    "capacity": 41031,
    "lat": 36.814,
    "lon": -119.758,
    "x": 75,
    "y": 295.1
  },
  "georgia": {
    "stadium": "Sanford Stadium",
    "city": "Athens",
    "state": "GA",
    "capacity": 92746,
    "lat": 33.95,
    "lon": -83.373,
    "x": 733.2,
    "y": 398.2
  },
  "georgia-southern": {
    "stadium": "Allen E. Paulson Stadium",
    "city": "Statesboro",
    "state": "GA",
    "capacity": 25000,
    "lat": 32.412,
    "lon": -81.785,
    "x": 767.8,
    "y": 428.7
  },
  "georgia-state": {
    "stadium": "Center Parc Stadium",
    "city": "Atlanta",
    "state": "GA",
    "capacity": 25000,
    "lat": 33.735,
    "lon": -84.39,
    "x": 715,
    "y": 405.4
  },
  "georgia-tech": {
    "stadium": "Bobby Dodd Stadium",
    "city": "Atlanta",
    "state": "GA",
    "capacity": 55000,
    "lat": 33.772,
    "lon": -84.393,
    "x": 714.8,
    "y": 404.6
  },
  "hawaii": {
    "stadium": "Clarence T.C. Ching Athletics Complex",
    "city": "Honolulu",
    "state": "HI",
    "capacity": 15194,
    "lat": 21.294,
    "lon": -157.819,
    "x": 267.8,
    "y": 549.5
  },
  "houston": {
    "stadium": "TDECU Stadium",
    "city": "Houston",
    "state": "TX",
    "capacity": 40000,
    "lat": 29.722,
    "lon": -95.349,
    "x": 510.8,
    "y": 510.1
  },
  "illinois": {
    "stadium": "Memorial Stadium",
    "city": "Champaign",
    "state": "IL",
    "capacity": 60670,
    "lat": 40.099,
    "lon": -88.236,
    "x": 631.4,
    "y": 267.5
  },
  "indiana": {
    "stadium": "Memorial Stadium",
    "city": "Bloomington",
    "state": "IN",
    "capacity": 52656,
    "lat": 39.181,
    "lon": -86.526,
    "x": 662.8,
    "y": 285.8
  },
  "iowa": {
    "stadium": "Kinnick Stadium",
    "city": "Iowa City",
    "state": "IA",
    "capacity": 69250,
    "lat": 41.659,
    "lon": -91.551,
    "x": 572.8,
    "y": 235.6
  },
  "iowa-state": {
    "stadium": "Jack Trice Stadium",
    "city": "Ames",
    "state": "IA",
    "capacity": 61500,
    "lat": 42.014,
    "lon": -93.636,
    "x": 537.6,
    "y": 228.7
  },
  "jacksonville-state": {
    "stadium": "AmFirst Stadium",
    "city": "Jacksonville",
    "state": "AL",
    "capacity": 24000,
    "lat": 33.82,
    "lon": -85.766,
    "x": 689.1,
    "y": 406.5
  },
  "james-madison": {
    "stadium": "Bridgeforth Stadium",
    "city": "Harrisonburg",
    "state": "VA",
    "capacity": 24877,
    "lat": 38.435,
    "lon": -78.873,
    "x": 797.8,
    "y": 284
  },
  "kansas": {
    "stadium": "Memorial Stadium",
    "city": "Lawrence",
    "state": "KS",
    "capacity": 47000,
    "lat": 38.963,
    "lon": -95.246,
    "x": 511.2,
    "y": 299
  },
  "kansas-state": {
    "stadium": "Bill Snyder Family Stadium",
    "city": "Manhattan",
    "state": "KS",
    "capacity": 50000,
    "lat": 39.202,
    "lon": -96.594,
    "x": 487.7,
    "y": 293.5
  },
  "kennesaw-state": {
    "stadium": "Fifth Third Stadium",
    "city": "Kennesaw",
    "state": "GA",
    "capacity": 11040,
    "lat": 34.029,
    "lon": -84.568,
    "x": 710.9,
    "y": 399.2
  },
  "kent-state": {
    "stadium": "Dix Stadium",
    "city": "Kent",
    "state": "OH",
    "capacity": 25319,
    "lat": 41.139,
    "lon": -81.313,
    "x": 746,
    "y": 230
  },
  "kentucky": {
    "stadium": "Kroger Field",
    "city": "Lexington",
    "state": "KY",
    "capacity": 61000,
    "lat": 38.022,
    "lon": -84.505,
    "x": 701,
    "y": 308.3
  },
  "liberty": {
    "stadium": "Williams Stadium",
    "city": "Lynchburg",
    "state": "VA",
    "capacity": 25000,
    "lat": 37.354,
    "lon": -79.175,
    "x": 797,
    "y": 309.3
  },
  "louisiana": {
    "stadium": "Cajun Field",
    "city": "Lafayette",
    "state": "LA",
    "capacity": 41426,
    "lat": 30.216,
    "lon": -92.042,
    "x": 575.5,
    "y": 497.3
  },
  "louisiana-tech": {
    "stadium": "Joe Aillet Stadium",
    "city": "Ruston",
    "state": "LA",
    "capacity": 28019,
    "lat": 32.532,
    "lon": -92.656,
    "x": 561.6,
    "y": 445.1
  },
  "louisville": {
    "stadium": "L&N Federal Credit Union Stadium",
    "city": "Louisville",
    "state": "KY",
    "capacity": 60000,
    "lat": 38.206,
    "lon": -85.759,
    "x": 678.5,
    "y": 306.6
  },
  "lsu": {
    "stadium": "Tiger Stadium",
    "city": "Baton Rouge",
    "state": "LA",
    "capacity": 102321,
    "lat": 30.412,
    "lon": -91.184,
    "x": 592,
    "y": 492.1
  },
  "marshall": {
    "stadium": "Joan C. Edwards Stadium",
    "city": "Huntington",
    "state": "WV",
    "capacity": 38016,
    "lat": 38.425,
    "lon": -82.421,
    "x": 736.2,
    "y": 294.3
  },
  "maryland": {
    "stadium": "SECU Stadium",
    "city": "College Park",
    "state": "MD",
    "capacity": 51802,
    "lat": 38.99,
    "lon": -76.947,
    "x": 828.6,
    "y": 265.1
  },
  "massachusetts": {
    "stadium": "Warren McGuirk Alumni Stadium",
    "city": "Hadley",
    "state": "MA",
    "capacity": 17000,
    "lat": 42.377,
    "lon": -72.536,
    "x": 884.8,
    "y": 172.9
  },
  "memphis": {
    "stadium": "Simmons Bank Liberty Stadium",
    "city": "Memphis",
    "state": "TN",
    "capacity": 58325,
    "lat": 35.121,
    "lon": -89.977,
    "x": 608.8,
    "y": 383.5
  },
  "miami": {
    "stadium": "Hard Rock Stadium",
    "city": "Miami Gardens",
    "state": "FL",
    "capacity": 64767,
    "lat": 25.958,
    "lon": -80.239,
    "x": 821.1,
    "y": 568.4
  },
  "miami-oh": {
    "stadium": "Yager Stadium",
    "city": "Oxford",
    "state": "OH",
    "capacity": 24286,
    "lat": 39.52,
    "lon": -84.733,
    "x": 692.9,
    "y": 274.7
  },
  "michigan": {
    "stadium": "Michigan Stadium",
    "city": "Ann Arbor",
    "state": "MI",
    "capacity": 107601,
    "lat": 42.266,
    "lon": -83.749,
    "x": 701.8,
    "y": 210.3
  },
  "michigan-state": {
    "stadium": "Spartan Stadium",
    "city": "East Lansing",
    "state": "MI",
    "capacity": 75005,
    "lat": 42.728,
    "lon": -84.485,
    "x": 688.3,
    "y": 201.3
  },
  "middle-tennessee": {
    "stadium": "Johnny \"Red\" Floyd Stadium",
    "city": "Murfreesboro",
    "state": "TN",
    "capacity": 30788,
    "lat": 35.851,
    "lon": -86.368,
    "x": 673.2,
    "y": 361.4
  },
  "minnesota": {
    "stadium": "Huntington Bank Stadium",
    "city": "Minneapolis",
    "state": "MN",
    "capacity": 50850,
    "lat": 44.977,
    "lon": -93.225,
    "x": 542.5,
    "y": 161
  },
  "mississippi-state": {
    "stadium": "Davis Wade Stadium",
    "city": "Starkville",
    "state": "MS",
    "capacity": 61337,
    "lat": 33.456,
    "lon": -88.793,
    "x": 633.4,
    "y": 419.9
  },
  "missouri": {
    "stadium": "Memorial Stadium",
    "city": "Columbia",
    "state": "MO",
    "capacity": 71168,
    "lat": 38.936,
    "lon": -92.333,
    "x": 562.1,
    "y": 298.4
  },
  "missouri-state": {
    "stadium": "Plaster Sports Complex",
    "city": "Springfield",
    "state": "MO",
    "capacity": 17337,
    "lat": 37.198,
    "lon": -93.28,
    "x": 546.7,
    "y": 338.8
  },
  "navy": {
    "stadium": "Navy-Marine Corps Memorial Stadium",
    "city": "Annapolis",
    "state": "MD",
    "capacity": 34000,
    "lat": 38.985,
    "lon": -76.508,
    "x": 836.1,
    "y": 263.7
  },
  "nc-state": {
    "stadium": "Carter-Finley Stadium",
    "city": "Raleigh",
    "state": "NC",
    "capacity": 58000,
    "lat": 35.801,
    "lon": -78.72,
    "x": 811.4,
    "y": 342.9
  },
  "nebraska": {
    "stadium": "Memorial Stadium",
    "city": "Lincoln",
    "state": "NE",
    "capacity": 85458,
    "lat": 40.821,
    "lon": -96.706,
    "x": 486,
    "y": 256.4
  },
  "nevada": {
    "stadium": "Mackay Stadium",
    "city": "Reno",
    "state": "NV",
    "capacity": 27000,
    "lat": 39.547,
    "lon": -119.818,
    "x": 89.5,
    "y": 234.2
  },
  "new-mexico": {
    "stadium": "University Stadium",
    "city": "Albuquerque",
    "state": "NM",
    "capacity": 39224,
    "lat": 35.067,
    "lon": -106.628,
    "x": 302.7,
    "y": 377.3
  },
  "new-mexico-state": {
    "stadium": "Aggie Memorial Stadium",
    "city": "Las Cruces",
    "state": "NM",
    "capacity": 28853,
    "lat": 32.28,
    "lon": -106.741,
    "x": 293.5,
    "y": 440.4
  },
  "north-carolina": {
    "stadium": "Kenan Stadium",
    "city": "Chapel Hill",
    "state": "NC",
    "capacity": 50500,
    "lat": 35.907,
    "lon": -79.048,
    "x": 805.1,
    "y": 341.6
  },
  "north-dakota-state": {
    "stadium": "Fargodome",
    "city": "Fargo",
    "state": "ND",
    "capacity": 18700,
    "lat": 46.903,
    "lon": -96.8,
    "x": 485.6,
    "y": 118
  },
  "north-texas": {
    "stadium": "DATCU Stadium",
    "city": "Denton",
    "state": "TX",
    "capacity": 30850,
    "lat": 33.204,
    "lon": -97.159,
    "x": 476.2,
    "y": 430.7
  },
  "northern-illinois": {
    "stadium": "Huskie Stadium",
    "city": "DeKalb",
    "state": "IL",
    "capacity": 23595,
    "lat": 41.934,
    "lon": -88.778,
    "x": 618.9,
    "y": 226.4
  },
  "northwestern": {
    "stadium": "Lanny and Sharon Martin Stadium",
    "city": "Evanston",
    "state": "IL",
    "capacity": 12023,
    "lat": 42.058,
    "lon": -87.671,
    "x": 637.2,
    "y": 222.1
  },
  "notre-dame": {
    "stadium": "Notre Dame Stadium",
    "city": "Notre Dame",
    "state": "IN",
    "capacity": 80795,
    "lat": 41.698,
    "lon": -86.234,
    "x": 661.9,
    "y": 228
  },
  "ohio": {
    "stadium": "Peden Stadium",
    "city": "Athens",
    "state": "OH",
    "capacity": 24000,
    "lat": 39.321,
    "lon": -82.103,
    "x": 738.8,
    "y": 273.2
  },
  "ohio-state": {
    "stadium": "Ohio Stadium",
    "city": "Columbus",
    "state": "OH",
    "capacity": 102780,
    "lat": 40.002,
    "lon": -83.02,
    "x": 720.9,
    "y": 260
  },
  "oklahoma": {
    "stadium": "Memorial Stadium",
    "city": "Norman",
    "state": "OK",
    "capacity": 86112,
    "lat": 35.206,
    "lon": -97.442,
    "x": 471.5,
    "y": 384.9
  },
  "oklahoma-state": {
    "stadium": "Boone Pickens Stadium",
    "city": "Stillwater",
    "state": "OK",
    "capacity": 55509,
    "lat": 36.126,
    "lon": -97.067,
    "x": 478.7,
    "y": 363.9
  },
  "old-dominion": {
    "stadium": "S.B. Ballard Stadium",
    "city": "Norfolk",
    "state": "VA",
    "capacity": 20118,
    "lat": 36.889,
    "lon": -76.305,
    "x": 849.5,
    "y": 310
  },
  "ole-miss": {
    "stadium": "Vaught-Hemingway Stadium",
    "city": "Oxford",
    "state": "MS",
    "capacity": 64038,
    "lat": 34.362,
    "lon": -89.534,
    "x": 618.1,
    "y": 400.3
  },
  "oregon": {
    "stadium": "Autzen Stadium",
    "city": "Eugene",
    "state": "OR",
    "capacity": 54000,
    "lat": 44.058,
    "lon": -123.068,
    "x": 64.1,
    "y": 120.3
  },
  "oregon-state": {
    "stadium": "Reser Stadium",
    "city": "Corvallis",
    "state": "OR",
    "capacity": 43363,
    "lat": 44.559,
    "lon": -123.281,
    "x": 64,
    "y": 108.4
  },
  "penn-state": {
    "stadium": "Beaver Stadium",
    "city": "University Park",
    "state": "PA",
    "capacity": 106572,
    "lat": 40.812,
    "lon": -77.856,
    "x": 805.1,
    "y": 227.3
  },
  "pittsburgh": {
    "stadium": "Acrisure Stadium",
    "city": "Pittsburgh",
    "state": "PA",
    "capacity": 68400,
    "lat": 40.447,
    "lon": -80.016,
    "x": 770.3,
    "y": 242.1
  },
  "purdue": {
    "stadium": "Ross-Ade Stadium",
    "city": "West Lafayette",
    "state": "IN",
    "capacity": 57282,
    "lat": 40.435,
    "lon": -86.919,
    "x": 653.2,
    "y": 257.9
  },
  "rice": {
    "stadium": "Rice Stadium",
    "city": "Houston",
    "state": "TX",
    "capacity": 47000,
    "lat": 29.716,
    "lon": -95.409,
    "x": 509.7,
    "y": 510.2
  },
  "rutgers": {
    "stadium": "SHI Stadium",
    "city": "Piscataway",
    "state": "NJ",
    "capacity": 52454,
    "lat": 40.514,
    "lon": -74.465,
    "x": 863.1,
    "y": 222
  },
  "sacramento-state": {
    "stadium": "Hornet Stadium",
    "city": "Sacramento",
    "state": "CA",
    "capacity": 21195,
    "lat": 38.556,
    "lon": -121.423,
    "x": 56.6,
    "y": 248.9
  },
  "sam-houston": {
    "stadium": "Elliott T. Bowers Stadium",
    "city": "Huntsville",
    "state": "TX",
    "capacity": 14000,
    "lat": 30.714,
    "lon": -95.542,
    "x": 506.9,
    "y": 487.6
  },
  "san-diego-state": {
    "stadium": "Snapdragon Stadium",
    "city": "San Diego",
    "state": "CA",
    "capacity": 35000,
    "lat": 32.784,
    "lon": -117.123,
    "x": 100.8,
    "y": 396.1
  },
  "san-jos-state": {
    "stadium": "CEFCU Stadium",
    "city": "San Jose",
    "state": "CA",
    "capacity": 30456,
    "lat": 37.32,
    "lon": -121.868,
    "x": 41.5,
    "y": 274.1
  },
  "smu": {
    "stadium": "Gerald J. Ford Stadium",
    "city": "University Park",
    "state": "TX",
    "capacity": 32000,
    "lat": 32.838,
    "lon": -96.783,
    "x": 483.2,
    "y": 439.1
  },
  "south-alabama": {
    "stadium": "Hancock Whitney Stadium",
    "city": "Mobile",
    "state": "AL",
    "capacity": 25450,
    "lat": 30.697,
    "lon": -88.192,
    "x": 649.8,
    "y": 481.8
  },
  "south-carolina": {
    "stadium": "Williams-Brice Stadium",
    "city": "Columbia",
    "state": "SC",
    "capacity": 80250,
    "lat": 33.973,
    "lon": -81.019,
    "x": 776.6,
    "y": 391.3
  },
  "south-florida": {
    "stadium": "Raymond James Stadium",
    "city": "Tampa",
    "state": "FL",
    "capacity": 65828,
    "lat": 27.976,
    "lon": -82.503,
    "x": 768.5,
    "y": 530.5
  },
  "southern-miss": {
    "stadium": "M. M. Roberts Stadium",
    "city": "Hattiesburg",
    "state": "MS",
    "capacity": 36000,
    "lat": 31.329,
    "lon": -89.332,
    "x": 626.7,
    "y": 469.1
  },
  "stanford": {
    "stadium": "Stanford Stadium",
    "city": "Stanford",
    "state": "CA",
    "capacity": 50424,
    "lat": 37.435,
    "lon": -122.161,
    "x": 37.1,
    "y": 270.2
  },
  "syracuse": {
    "stadium": "JMA Wireless Dome",
    "city": "Syracuse",
    "state": "NY",
    "capacity": 49057,
    "lat": 43.036,
    "lon": -76.136,
    "x": 823.3,
    "y": 171.7
  },
  "tcu": {
    "stadium": "Amon G. Carter Stadium",
    "city": "Fort Worth",
    "state": "TX",
    "capacity": 46000,
    "lat": 32.71,
    "lon": -97.368,
    "x": 472.1,
    "y": 441.9
  },
  "temple": {
    "stadium": "Lincoln Financial Field",
    "city": "Philadelphia",
    "state": "PA",
    "capacity": 69879,
    "lat": 39.901,
    "lon": -75.168,
    "x": 854.5,
    "y": 238.3
  },
  "tennessee": {
    "stadium": "Neyland Stadium",
    "city": "Knoxville",
    "state": "TN",
    "capacity": 102455,
    "lat": 35.955,
    "lon": -83.925,
    "x": 717.2,
    "y": 354
  },
  "texas": {
    "stadium": "DKR-Texas Memorial Stadium",
    "city": "Austin",
    "state": "TX",
    "capacity": 100119,
    "lat": 30.284,
    "lon": -97.733,
    "x": 464.1,
    "y": 497.1
  },
  "texas-a-m": {
    "stadium": "Kyle Field",
    "city": "College Station",
    "state": "TX",
    "capacity": 102733,
    "lat": 30.61,
    "lon": -96.34,
    "x": 491.4,
    "y": 490
  },
  "texas-state": {
    "stadium": "Bobcat Stadium",
    "city": "San Marcos",
    "state": "TX",
    "capacity": 30000,
    "lat": 29.891,
    "lon": -97.926,
    "x": 460.2,
    "y": 505.9
  },
  "texas-tech": {
    "stadium": "Jones AT&T Stadium",
    "city": "Lubbock",
    "state": "TX",
    "capacity": 60454,
    "lat": 33.591,
    "lon": -101.873,
    "x": 387.9,
    "y": 418.6
  },
  "toledo": {
    "stadium": "Glass Bowl",
    "city": "Toledo",
    "state": "OH",
    "capacity": 26038,
    "lat": 41.657,
    "lon": -83.614,
    "x": 705.8,
    "y": 223.8
  },
  "troy": {
    "stadium": "Veterans Memorial Stadium",
    "city": "Troy",
    "state": "AL",
    "capacity": 30000,
    "lat": 31.8,
    "lon": -85.952,
    "x": 690.6,
    "y": 452.7
  },
  "tulane": {
    "stadium": "Yulman Stadium",
    "city": "New Orleans",
    "state": "LA",
    "capacity": 30000,
    "lat": 29.945,
    "lon": -90.117,
    "x": 613.5,
    "y": 501.5
  },
  "tulsa": {
    "stadium": "Chapman Stadium",
    "city": "Tulsa",
    "state": "OK",
    "capacity": 30000,
    "lat": 36.149,
    "lon": -95.944,
    "x": 499,
    "y": 363.5
  },
  "uab": {
    "stadium": "Protective Stadium",
    "city": "Birmingham",
    "state": "AL",
    "capacity": 45000,
    "lat": 33.521,
    "lon": -86.802,
    "x": 670.5,
    "y": 415.3
  },
  "ucf": {
    "stadium": "FBC Mortgage Stadium",
    "city": "Orlando",
    "state": "FL",
    "capacity": 44206,
    "lat": 28.608,
    "lon": -81.193,
    "x": 792.4,
    "y": 512.4
  },
  "ucla": {
    "stadium": "Rose Bowl",
    "city": "Pasadena",
    "state": "CA",
    "capacity": 88565,
    "lat": 34.161,
    "lon": -118.168,
    "x": 88.8,
    "y": 361
  },
  "uconn": {
    "stadium": "Pratt & Whitney Stadium",
    "city": "East Hartford",
    "state": "CT",
    "capacity": 40000,
    "lat": 41.76,
    "lon": -72.619,
    "x": 886.9,
    "y": 186.9
  },
  "ul-monroe": {
    "stadium": "Malone Stadium",
    "city": "Monroe",
    "state": "LA",
    "capacity": 27617,
    "lat": 32.531,
    "lon": -92.066,
    "x": 572.8,
    "y": 444.7
  },
  "unlv": {
    "stadium": "Allegiant Stadium",
    "city": "Las Vegas",
    "state": "NV",
    "capacity": 65000,
    "lat": 36.091,
    "lon": -115.184,
    "x": 151.9,
    "y": 329.8
  },
  "usc": {
    "stadium": "Los Angeles Memorial Coliseum",
    "city": "Los Angeles",
    "state": "CA",
    "capacity": 77500,
    "lat": 34.014,
    "lon": -118.288,
    "x": 85.8,
    "y": 363.8
  },
  "utah": {
    "stadium": "Rice-Eccles Stadium",
    "city": "Salt Lake City",
    "state": "UT",
    "capacity": 51444,
    "lat": 40.76,
    "lon": -111.849,
    "x": 229.2,
    "y": 235.4
  },
  "utah-state": {
    "stadium": "Maverik Stadium",
    "city": "Logan",
    "state": "UT",
    "capacity": 25513,
    "lat": 41.752,
    "lon": -111.812,
    "x": 233.6,
    "y": 213.1
  },
  "utep": {
    "stadium": "Sun Bowl",
    "city": "El Paso",
    "state": "TX",
    "capacity": 51500,
    "lat": 31.773,
    "lon": -106.508,
    "x": 296.6,
    "y": 452.3
  },
  "utsa": {
    "stadium": "Alamodome",
    "city": "San Antonio",
    "state": "TX",
    "capacity": 36582,
    "lat": 29.417,
    "lon": -98.479,
    "x": 449,
    "y": 516.4
  },
  "vanderbilt": {
    "stadium": "FirstBank Stadium",
    "city": "Nashville",
    "state": "TN",
    "capacity": 40351,
    "lat": 36.144,
    "lon": -86.809,
    "x": 664.6,
    "y": 355.5
  },
  "virginia": {
    "stadium": "Scott Stadium",
    "city": "Charlottesville",
    "state": "VA",
    "capacity": 61500,
    "lat": 38.031,
    "lon": -78.514,
    "x": 805.7,
    "y": 292
  },
  "virginia-tech": {
    "stadium": "Lane Stadium",
    "city": "Blacksburg",
    "state": "VA",
    "capacity": 65632,
    "lat": 37.22,
    "lon": -80.418,
    "x": 775.6,
    "y": 316.1
  },
  "wake-forest": {
    "stadium": "Allegacy Federal Credit Union Stadium",
    "city": "Winston-Salem",
    "state": "NC",
    "capacity": 31500,
    "lat": 36.131,
    "lon": -80.255,
    "x": 782.6,
    "y": 340.3
  },
  "washington": {
    "stadium": "Husky Stadium",
    "city": "Seattle",
    "state": "WA",
    "capacity": 70138,
    "lat": 47.65,
    "lon": -122.302,
    "x": 98.3,
    "y": 45.5
  },
  "washington-state": {
    "stadium": "Gesa Field",
    "city": "Pullman",
    "state": "WA",
    "capacity": 32952,
    "lat": 46.732,
    "lon": -117.16,
    "x": 170.4,
    "y": 85.3
  },
  "west-virginia": {
    "stadium": "Milan Puskar Stadium",
    "city": "Morgantown",
    "state": "WV",
    "capacity": 60000,
    "lat": 39.65,
    "lon": -79.955,
    "x": 774.4,
    "y": 259.9
  },
  "western-kentucky": {
    "stadium": "Houchens Industries-L.T. Smith Stadium",
    "city": "Bowling Green",
    "state": "KY",
    "capacity": 22113,
    "lat": 36.985,
    "lon": -86.459,
    "x": 669,
    "y": 335.7
  },
  "western-michigan": {
    "stadium": "Waldo Stadium",
    "city": "Kalamazoo",
    "state": "MI",
    "capacity": 30200,
    "lat": 42.286,
    "lon": -85.601,
    "x": 671.1,
    "y": 213.5
  },
  "wisconsin": {
    "stadium": "Camp Randall Stadium",
    "city": "Madison",
    "state": "WI",
    "capacity": 80321,
    "lat": 43.07,
    "lon": -89.413,
    "x": 606.5,
    "y": 201.3
  },
  "wyoming": {
    "stadium": "War Memorial Stadium",
    "city": "Laramie",
    "state": "WY",
    "capacity": 29181,
    "lat": 41.312,
    "lon": -105.568,
    "x": 336.5,
    "y": 237.1
  }
};

export default STADIUMS;
